/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ import { useEffect, useLayoutEffect } from 'react';

export const useIsomorphicLayoutEffect = /* @__PURE__ */ (() =>
	/* istanbul ignore next */
	typeof window === 'undefined' ? useEffect : useLayoutEffect)();
